import { apiClient } from "../App";

// ======================
// User Groups APIs
// ======================

// Get All Groups (extra me search key aati hai)
export const getUserGroups = (extra = {}) => {
  return apiClient.get("/user-groups/", { params: extra });
};

export const getUsers = (dept = "all", extra = {}) => {
  const params = { ...extra };
  if (dept && dept !== "all") params.department = dept;
  return apiClient.get("/users/", { params });
};


export const getDepartments = () => {
  return apiClient.get("/departments/");
};

// Create Group
export const createUserGroup = (data) => {
  return apiClient.post("/user-groups/", data);
};

// Update Group
export const updateUserGroup = (id, data) => {
  return apiClient.put(`/user-groups/${id}`, data);
};

// Delete Group
export const deleteUserGroup = (id) => {
  return apiClient.delete(`/user-groups/${id}`);
};

// Update Members
export const updateGroupMembers = (id, data) => {
  return apiClient.put(`/user-groups/${id}/members/`, data);
};